import { useCallback, useEffect, useRef, useMemo } from "react";

import FilterWrapper from "@stadium/shared/src/components/filter";
import { DropdownItem } from "@stadium/ui/src/components/bootstrap-dropdown";
import { InternalButton } from "@sharedComponents/buttons";

import { useFilter } from "@stadium/shared/src/hooks/use-filter";
import { useShopAnalyticsContext } from "@hooks/analytics/use-shop-analytics-context";
import { ANALYTICS_TARGET_FILTER } from "@constants/analytics/filter";

import style from "../filterDropdown.module.scss";
/**
 * Responsive drawer content: selections live in Redux state.
 * Syncs directly via updateUrl hook.
 */
const FilterV2DrawerContent = ({
  config,
  setIsDropdownOpen,
  currentOptionKey,
  setCurrentOptionKey,
}) => {
  const { clear } = useFilter();
  const containerRef = useRef(null);
  const shopAnalyticsContext = useShopAnalyticsContext();

  const eventLocationAnalytics = useMemo(
    () => ({
      track: !!shopAnalyticsContext.shop_number,
      target: ANALYTICS_TARGET_FILTER,
      eventProperties: shopAnalyticsContext,
    }),
    [shopAnalyticsContext],
  );

  // Scroll to top when view changes (entering and exiting View All)
  useEffect(() => {
    if (containerRef.current) {
      const drawerContent = containerRef.current.closest(`.${style.dropdownMenu}`);
      if (drawerContent) {
        drawerContent.scrollTop = 0;
      }
    }
  }, [currentOptionKey]);

  const handleApply = useCallback(() => {
    setIsDropdownOpen(false);
  }, [setIsDropdownOpen]);

  const activeConfig = useMemo(() => {
    if (currentOptionKey) {
      const activeGroup = config.find((group) => group.id === currentOptionKey);
      if (activeGroup) {
        return [
          {
            ...activeGroup,
            defaultOpen: true,
            label: "", // Hide inner label since it's already in the Drawer header
            showViewAll: false,
          },
        ];
      }
    }
    return config;
  }, [config, currentOptionKey]);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <FilterWrapper
        key={currentOptionKey || "base"}
        config={activeConfig}
        isResponsiveView
        eventLocationAnalytics={eventLocationAnalytics}
        onViewAll={({ filterItemId }) => {
          setCurrentOptionKey(filterItemId);
        }}
      />

      <div className={style.mobileFilterFooterBtn}>
        <DropdownItem className={style.button}>
          <InternalButton styleType="primary-outline" onClick={() => clear()}>
            Clear Filters
          </InternalButton>
        </DropdownItem>
        <DropdownItem className={style.button}>
          <InternalButton onClick={handleApply}>Apply</InternalButton>
        </DropdownItem>
      </div>
    </div>
  );
};

export default FilterV2DrawerContent;
